export const API_URL = (
  process.env.REACT_APP_API_URL ||
  "https://sales-floor-dashboard.anurag-prajapat.workers.dev"
).replace(/\/+$/, "");

export const ENABLE_DSR = process.env.REACT_APP_ENABLE_DSR === "true";
